// extracted by mini-css-extract-plugin
export default {"titleWrapper":"WizardHeaderSearch_titleWrapper__8yWBK","titleText":"WizardHeaderSearch_titleText__GkUr+","item":"WizardHeaderSearch_item__Haz5z"};